export default function Online3DViewer({
  fileUrl,
  className = "",
}: {
  fileUrl: string;
  className?: string;
}) {
  return (
    <iframe
      src={`/Online3DViewer/website/index.html#model=${fileUrl}`}
      className={className}
    />
  );
}
